module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "max-width": "500px"
    },
    attrs: {
      "id": "login-overlay"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [(_vm.error) ? _c('div', {
    staticClass: "alert alert-danger alert-dismissible"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), (_vm.notification) ? _c('div', {
    staticClass: "alert alert-success alert-dismissible"
  }, [_vm._m(2), _vm._v(" "), _c('strong'), _vm._v(_vm._s(_vm.notification) + "\r\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "well",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('div', [_c('div', {
    staticClass: "form-group "
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "username"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "inner-addon right-addon"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), (_vm.credentials.username) ? _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.errors.has('email')),
      expression: "!errors.has('email')"
    }],
    staticClass: "fa fa-paw text-success "
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.username),
      expression: "credentials.username"
    }],
    staticClass: "form-control",
    class: {
      'input': true, 'has-error': _vm.errors.has('email')
    },
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Email address",
      "lazy": ""
    },
    domProps: {
      "value": (_vm.credentials.username)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.validateBeforeSubmit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help-inline text-danger h5"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "inner-addon right-addon"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), (_vm.credentials.password) ? _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.errors.has('password')),
      expression: "!errors.has('password')"
    }],
    staticClass: "fa fa-paw text-success "
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:4'),
      expression: "'required|min:4'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    staticClass: "form-control",
    class: {
      'input': true, 'has-error': _vm.errors.has('password')
    },
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Password",
      "data-vv-delay": "1000"
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.validateBeforeSubmit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "text-danger h5"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-block btn-title",
    attrs: {
      "disabled": _vm.filledRequiredComp == false
    },
    on: {
      "click": function($event) {
        _vm.validateBeforeSubmit()
      }
    }
  }, [_vm._v("Login")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header text-center",
    staticStyle: {
      "padding-top": "0px !important",
      "padding-bottom": "0px !important"
    }
  }, [_c('h2', [_vm._v("Welcome to Dupaws.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32b6a288!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/AdminLogin.vue
// module id = 623
// module chunks = 2